import { render, staticRenderFns } from "./HdsTooltip.vue?vue&type=template&id=0ae52ba1&scoped=true&"
import script from "./HdsTooltip.vue?vue&type=script&lang=ts&"
export * from "./HdsTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./HdsTooltip.vue?vue&type=style&index=0&id=0ae52ba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae52ba1",
  null
  
)

export default component.exports